var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 94.337,
    height: 38.282,
    viewBox: "0 0 94.337 38.282",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -4.418,
    y1: 7.267,
    x2: -4.384,
    y2: 7.267,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe04f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -4.82,
    y1: 10.219,
    x2: -4.777,
    y2: 10.219,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcd00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -3.234,
    y1: 7.267,
    x2: -3.2,
    y2: 7.267,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.126,
    y1: 0.908,
    x2: 0.814,
    y2: 0.055,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc4a1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.755,
    y1: 0.032,
    x2: 2.659,
    y2: 1.373,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc4a1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f1c08"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-478 -635)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M199.86,42.063s3.174.346,8.677,7.452c6.741,8.7,9.253,12.527,11.29,12.527,2.423,0,5.017-4.89,8.558-13.174,0,0-6.3,8.46-13.063,1.618s-8.27-8.547-11.059-11.255c0,0-3.653.245-4.4,2.836Z",
    transform: "translate(343.952 609.318)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M157.5,51.407a99.216,99.216,0,0,0,7.507-6.7c2.983-3.07,7.586-8.2,9.683-8.317s2.867.113,5.567,3.566c0,0-5.716-2.163-8.722,2.046,0,0-4.729,6.263-5.78,8.1,0,0-5.855,4.319-8.255,1.3Z",
    transform: "translate(370.476 611.102)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M108.43,42.063s3.174.346,8.677,7.452c6.741,8.7,9.257,12.527,11.291,12.527,2.423,0,4.961-5.278,8.655-13.155,0,0-6.4,8.438-13.16,1.6s-8.27-8.547-11.059-11.255c0,0-3.653.245-4.4,2.836Z",
    transform: "translate(401.2 609.318)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M34.2,57.278s-1.8-2.268.449-2.268c0,0,4.845,2.915,19.557-13.554,0,0,5.544-5.932,8.408-5.616,2.011-.068,3.35.835,4.7,2.6a10.312,10.312,0,0,0-7.776,2.8c-3.585,3.344-7.432,8.908-12.5,14.419,0,0-1.35,3.89-8.9,5.184,0,0-2.138-.32-3.937-3.559Z",
    transform: "translate(448.109 611.441)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_298",
    "data-name": "Group 298",
    transform: "translate(478.001 635)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M49.655,25.012a81.587,81.587,0,0,1-5.313,8.11c-2.961,3.818-4.864,5.507-7.358,6.914-5.313,2.994-9.948,1.55-11.975-5.9-3.185-11.7.108-24.527,9.361-29.744,4.651-2.626,7.933-.6,9,3.322,1.155,4.255-.224,9.468-3.626,13.648A32.2,32.2,0,0,1,28.73,29.835a25.664,25.664,0,0,0,.557,2.765c1.477,5.947,4.98,6.143,8.98,3.882a24.4,24.4,0,0,0,4.314-3.668c2.273-2.415,7.066-7.806,7.066-7.806ZM33.769,6.628c-4.071,2.291-6.045,11.71-5.17,21.6a18.466,18.466,0,0,0,7.492-6.4c2.378-3.228,3.563-7.764,2.538-11.53-.8-2.942-2.434-5.045-4.86-3.675Z",
    transform: "translate(-23.828 -3.214)",
    fill: "url(#linear-gradient-5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmLogo);
export default __webpack_public_path__ + "static/media/em-logo.c8db824085c2a9a8b343d4a2507f8194.svg";
export { ForwardRef as ReactComponent };